module.exports = __webpack_public_path__ + "img/start.a3fd3a1b.webp";